import $ from "../../global/util";

export default {
  GET_OUTLETS: {
    PATH: "/outlets.json",
  },
};
